import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { X, LayoutGrid, LogOut, Percent } from 'lucide-react';
import { selectCategories } from '../store/slices/dressesSlice';
import { clearFilters } from '../store/slices/filtersSlice';
import { selectIsAuthenticated, selectUser, logoutAdmin } from '../store/slices/authSlice';

const CategoryDrawer = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector(selectCategories);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);

  if (!open) return null;

  const goToCategory = (id) => {
    onClose();
    navigate(`/category/${id}`);
  };

  const goToAllCategories = () => {
    onClose();
    dispatch(clearFilters());
    navigate('/products');
  };

  const goToDiscounts = () => {
    onClose();
    navigate('/discounts');
  };

  const handleLogout = async () => {
    onClose();
    try {
      await dispatch(logoutAdmin()).unwrap();
    } catch (_) {}
    navigate('/admin/login');
  };

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute left-0 top-0 h-full w-full max-w-xs bg-white shadow-2xl flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-center gap-2">
            <LayoutGrid className="w-4 h-4 text-primary-600" />
            <h3 className="text-base font-semibold text-gray-900">Categories</h3>
          </div>
          <button onClick={onClose} className="p-1 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-3 py-3 space-y-1">
          <button
            onClick={goToAllCategories}
            className="flex items-center w-full px-3 py-2.5 text-sm rounded-lg text-gray-700 hover:bg-gray-50 font-medium transition-colors"
          >
            All Categories
          </button>
          <button
            onClick={goToDiscounts}
            className="flex items-center gap-1.5 w-full px-3 py-2.5 text-sm rounded-lg text-red-500 hover:bg-red-50 font-semibold transition-colors"
          >
            <Percent className="w-3.5 h-3.5" />
            Discount
          </button>
          {categories.map(cat => (
            <button
              key={cat.id}
              onClick={() => goToCategory(cat.id)}
              className="flex items-center w-full px-3 py-2.5 text-sm rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              {cat.name}
            </button>
          ))}
        </div>

        {isAuthenticated && (
          <div className="border-t border-gray-100 p-3 flex-shrink-0">
            <div className="px-3 py-1.5 text-xs text-gray-500">
              Logged in as <span className="font-medium text-gray-900">{user?.username}</span>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 w-full px-3 py-2.5 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryDrawer;
